module.exports = __webpack_public_path__ + "assets/message-orange-ab806eeb9f7beed59707cf3b04fb3b94.svg";